import React, { Component } from "react";
import {
  withRouter,
  RouteComponentProps,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { Layout } from "antd";

import { VhNoAuth } from "msd";
import { MsApp } from "msd/dist/ms-header";
import { VhMenu } from "msd/dist/vh-sider";
import MsAsyncComponent from "./MsAsyncComponent";
import App from "components/ms-app/MsApp";

import { ApplicationState } from "store";
import {
  APP_CODE,
  HOME_PAGE,
  PERSONAL_PAGE,
  COMPANY_PAGE,
  LOGIN_URL,
  TOKEN,
  CID,
  LOGO_COLORFUL,
  DOMAIN
} from "common/constants";
import { IUser, ICompany } from "common/types";
import {
  fetchLogout,
  fetchUserInfo,
  fetchAppSave,
  fetchGetProjectSetting,
} from "store/authorization/actions";
import "./MsLayout.scss";
import MsHeader from "components/ms-common/ms-header";
import { fetchPersonalCompanyList, updateHomeState } from "store/home/actions";
import { MyCompany } from "store/home/types";

import { loadMicroApp, start, prefetchApps } from "qiankun";

import fetchApi from "utils/fetchApi";

/**
 * state props
 *
 * @interface PropsFromState
 */
interface PropsFromState {
  user: IUser;
  companyInfo: ICompany;
  configAppList: MsApp[];
  myCompanyList: MyCompany[];
  appList: MsApp[];
  appInfo: MsApp;
  menuList: VhMenu[];
  loading: boolean;
  projectSetting: any;
}

/**
 * dispatch props
 *
 * @interface PropsFromDispatch
 */
interface PropsFromDispatch {
  fetchLogout: typeof fetchLogout.request;
  fetchAppSave: typeof fetchAppSave.request;
  fetchUserInfo: typeof fetchUserInfo.request;
  fetchPersonalCompanyList: typeof fetchPersonalCompanyList.request;
  updateHomeState: typeof updateHomeState.request;
  fetchGetProjectSetting: typeof fetchGetProjectSetting.request;
}

// 类型合并
type AllProps = PropsFromState & PropsFromDispatch & RouteComponentProps;

// 关联state到组件props
const mapStateToProps = ({
  authorizationState,
  homeState,
}: ApplicationState) => ({
  user: authorizationState.userInfo,
  companyInfo: authorizationState.companyInfo,
  myCompanyList: homeState.myCompanyList,
  configAppList: authorizationState.configAppList,
  appList: authorizationState.appList,
  appInfo: authorizationState.appInfo,
  menuList: authorizationState.menuList,
  loading: authorizationState.loading,
  projectSetting: authorizationState.projectSetting,
});

// 关联dispatch到组件props
const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchUserInfo: () => dispatch(fetchUserInfo.request()),
  fetchPersonalCompanyList: (params: any) =>
    dispatch(fetchPersonalCompanyList.request(params)),
  fetchAppSave: (params: any) => dispatch(fetchAppSave.request(params)),
  fetchLogout: () => dispatch(fetchLogout.request()),
  updateHomeState: (params: any) => dispatch(updateHomeState.request(params)),
  fetchGetProjectSetting: (params: any) => dispatch(fetchGetProjectSetting.request(params)),
});

// 组件懒加载引入
const MsHome = MsAsyncComponent(() => import("../ms-home/MsHome"));
const noAuth = () => <VhNoAuth homePage={HOME_PAGE} />;

/**
 * 布局
 *
 * @class MsLayout
 * @extends {Component}
 */
class MsLayout extends Component<AllProps> {
  /**
   * Creates an instance of MsLayout.
   * @param {AllProps} props
   * @memberof MsLayout
   */
  constructor(props: AllProps) {
    super(props);

    this.props.fetchGetProjectSetting({ templateType: 10, domain: DOMAIN });
    // 获取登录用户信息
    this.props.fetchUserInfo();
    /**获取用户公司列表 */
    this.props.fetchPersonalCompanyList();
  }

  public async componentDidMount(): Promise<void> {
    // 预加载微模块系统
    prefetchApps([
      {
        name: "moss-viphrm",
        entry: `//${
          process.env.REACT_APP_ENV === "pro" ? "" : "pre"
        }micromodule.${DOMAIN}`,
        // entry: "//localhost:20010",
      },
    ]);
    // let logoUrl = "xxxx";
    // try {
    //     const res = await fetchApi("post", "api/platform-manager/api/manager/font-page-meta-info/queryTenantFontPageStyleByDomain", { templateType: 10, domain: DOMAIN });
    //     if (
    //     res.result === 0 &&
    //     Object.keys(res.data).length &&
    //     res.data.formatTemplateJson
    //   ) {
    //     console.log("111111111111111111", JSON.parse(res.data.formatTemplateJson))
    //     logoUrl = "xssdsdsd";
    //   }
    // } catch (e) {
    //     console.log(e);
    // }

    // 手动加载微模块系统中的各模块
    loadMicroApp({
      name: "moss-viphrm",
      entry: `//${
        process.env.REACT_APP_ENV === "pro" ? "" : "pre"
      }micromodule.${DOMAIN}`,
      container: "#headerView",
      props: {
        token: TOKEN,
        cid: CID,
        microModule: "ms-header",
        microModuleHost: `https://${
          process.env.REACT_APP_ENV === "pro" ? "" : "pre"
        }micromodule.${DOMAIN}`,
        sourceAppCode: APP_CODE,
        headerLogo: LOGO_COLORFUL,
      },
    });

    start();
  }

  /**
   * 保存常用应用
   *
   * @memberof MsLayout
   */
  public onSave = (ids: string[]) => {
    this.props.fetchAppSave({
      appIds: ids.join(","),
    });
  };

  /**
   * 登出
   *
   * @memberof MsLayout
   */
  public onLogout = () => {
    this.props.fetchLogout();
    window.location.href = LOGIN_URL;
  };

  /**切换公司 */
  public toggleCompany = () => {
    this.props.updateHomeState({
      switchCompanyModal: true,
    });
  };

  public onRef = () => {
    console.log("onRef");
  };

  public toggleCollapse = () => {
    console.log("toggleCollapse");
  };

  /**
   * 渲染模板
   *
   * @returns
   * @memberof MsLayout
   */
  public render() {
    const { user } = this.props;
    const toHome = () => <Redirect to="/" />;
    const toPersonal = () => {
      window.location.href = PERSONAL_PAGE;
      return null;
    };
    const toCompany = () => {
      window.location.href = COMPANY_PAGE;
      return null;
    };
    const toSwitch = () => {
      const params = new URLSearchParams(this.props.location.search);
      const type = params.get("type");

      if (type === "1") {
        return toCompany();
      } else if (type === "2") {
        return toPersonal();
      } else {
        return toHome();
      }
    };
    console.log(888, user, this.props.companyInfo);
    console.log("projectSetting ==============================> ", this.props.projectSetting)
    document.title = this.props.projectSetting?.mossBrowserTitle || "E+系统-人力资源效率化作业平台";
    return (
      <Layout style={{ height: "100%" }}>
        {/* <MsHeader 
          companyInfo = { this.props.companyInfo }
          appList={ this.props.appList } 
          selectedApp={ APP_CODE } 
          myCompanyList = { this.props.myCompanyList }
          onSave={ this.onSave } 
          onLogout={ this.onLogout } 
          name={ this.props.user.realName } 
          picture={ this.props.user.picture } 
          homePage={ HOME_PAGE } /> */}
        {/* 各项目公用header */}
        <div id="headerView" />
        <Layout className="ms-content">
          {user && user.userId ? (
            <Layout style={{ height: "100%" }}>
              <Switch>
                <Route path="/" exact={true} component={MsHome} />
                <Route path="/no-auth" exact={true} component={noAuth} />
                <Route path="/app" exact={true} component={App} />
                <Route path="/ssdbSessInit.php" render={toSwitch} />
                <Route path="//ssdbSessInit.php" render={toSwitch} />
                <Route path="/ui/homepage" render={toHome} />
                <Route path="/ui/personalcenter" render={toPersonal} />
                <Route path="/ui/managercenter" render={toCompany} />
                <Redirect to="/404" />
              </Switch>
            </Layout>
          ) : null}
        </Layout>
      </Layout>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MsLayout)
);
